<template>
  <fts-client-modal
    append-to-body
    dynamic-screen
    width="1280px"
    :title="diagramData.name"
    append-container-class="flow-diagram-modal-container"
    class="fts-flow-diagram-modal"
    @closed="reset"
    ref="ftsClientModal"
  >
    <div slot="icon" class="flow-diagram-emoji" v-if="diagramData.emoji">
      <fts-moji :size="18" :emoji="diagramData.emoji" />
    </div>
    <template #body>
      <fts-flow-diagram :diagram-data="diagramData" />
    </template>
  </fts-client-modal>
</template>

<script>
import Vue from 'vue';
import FTSClientModal from './FTSClientModal';
import FTSFlowDiagram from './FTSFlowDiagram';
import FTSMoji from './FTSMoji';

export default {
  components: {
    "fts-client-modal": FTSClientModal,
    "fts-moji": FTSMoji
  },
  data: () => ({
    diagramData: {}
  }),
  methods: {
    show(diagramData) {
      this.diagramData = diagramData;
      this.$refs.ftsClientModal.show();
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this));
    }
  },
  beforeCreate() {
    Vue.component("fts-flow-diagram", FTSFlowDiagram);
  }
}
</script>

<style lang="scss">
.fts-flow-diagram-modal {
  .flow-diagram-modal-container {
    height: 100%;
  }
  .flow-diagram-emoji {
    height: 1.75rem;
    display: flex;
    align-items: center;
  }
}
</style>